<template>
    <div class="popularize">
        <img class="top-banner" :src="`${GET_STATIC_IMG_HOST}popularize/others/banner4.jpg`">
        <div class="content-wrapper">
            <div class="top-context">
                <p>作品有声化出版平台，6大福利扶持新人，致力为好声音们打造专属舞台</p>
                <p>生财致富靠播音，年入百万不是梦</p>
                <p>开放平台，收益看得见，随时可提现</p>
                <p>加入我们，这些福利将属于你</p>
            </div>
            <div class="separate-line"></div>
            <div class="benefits-wrapper">
                <span class="title">- 你将拥有 -</span>
                <div class="benefits">
                    <div class="benefit" style="padding-right: 0; padding-bottom: 0;">
                        <div class="top" style="margin: 0;">
                            <i class="icon icon-50 icon-popularize-copyright"></i>
                            <span class="sub-title">版权保障</span>
                        </div>
                        <p style="padding: 50px 37px 120px 0;border-right: 1px solid #d9d9d9;">喜马拉雅联手阅文集团、博集天卷、果麦文化、读客图书、电子工业出版社、清华大学出版社等多家图书行业领军企业，共同制造正版有声作品</p>
                    </div>
                    <div class="benefit" style="padding-left: 37px;">
                        <div class="top">
                            <i class="icon icon-50 icon-popularize-earn"></i>
                            <span class="sub-title">丰厚收益</span>
                        </div>
                        <p>任务有保底、分成等多种收益，主播可长期享受有声作品的广告分成+打赏分成，每月结算，手机自助提现</p>
                    </div>
                    <div class="benefit" style="border-right: 1px solid #d9d9d9;">
                        <div class="top">
                            <i class="icon icon-50 icon-popularize-data"></i>
                            <span class="sub-title">数据分析服务</span>
                        </div>
                        <p>通过认证的主播或机构即可接受任务邀请获得收益，并同时享受定时发布、数据分析、无限空间等多项特权服务，准确的数据分析，让主播更好的了解专辑收听情况，便于改善优化作品</p>
                    </div>
                    <div class="benefit" style="padding-left: 37px;">
                        <div class="top">
                            <i class="icon icon-50 icon-popularize-broadcast"></i>
                            <span class="sub-title">优质的推广资源</span>
                        </div>
                        <p>喜马拉雅FM，拥有4亿海量用户，你的作品将在这里被万千声音爱好者熟知，并伴有优质资源位鼓励</p>
                    </div>
                    <div class="benefit" style="border-bottom:0;border-right: 1px solid #d9d9d9;">
                        <div class="top">
                            <i class="icon icon-50 icon-popularize-identification"></i>
                            <span class="sub-title">官方认证</span>
                        </div>
                        <p>喜马拉雅官方认证后将通过网站、移动、无线等全渠道展示并推广您的有声作品，签约主播还可享受高端广告资源</p>
                    </div>
                    <div class="benefit" style="border-bottom:0;padding-left: 37px;">
                        <div class="top">
                            <i class="icon icon-50 icon-popularize-chance"></i>
                            <span class="sub-title">海量机会</span>
                        </div>
                        <p>千万本实体书籍、网络书籍、绘本读物、报刊杂志都在等待您的精彩演播，周周都有新任务发布</p>
                    </div>
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="teamwork-wrapper">
                <span class="title">- 专业的团队配置 -</span>
                <div class="teamwork-list">
                    <div class="teamwork">
                        <img :src="`${GET_STATIC_IMG_HOST}popularize/day4/afternoon.png`">
                        <p>编辑团队：有条不紊的编辑团队，将一个个作品，进行精致打磨，并呈现给用户</p>
                    </div>
                    <div class="teamwork">
                        <img :src="`${GET_STATIC_IMG_HOST}popularize/day4/books.png`">
                        <p>版权团队：高效的版权团队，小伙伴们致力于将业内最优质的作品签约至作品有声化平台，为内容规模与质量提供了强有力的保证</p>
                    </div>
                    <div class="teamwork">
                        <img :src="`${GET_STATIC_IMG_HOST}popularize/day4/morning.png`">
                        <p>运营团队：喜马拉雅拥有完善的作品运营体系，将打磨后的作品精心挑选，量身定做包装形式，一一呈现给用户</p>
                    </div>
                    <div class="teamwork">
                        <img :src="`${GET_STATIC_IMG_HOST}popularize/day4/design.png`">
                        <p>研发团队：高效迭代的研发团队，保证了作品有声化平台的完善运行</p>
                    </div>
                </div>
            </div>
            <div class="separate-line"></div>
            <div class="more-wrapper">
                <span class="title">- 了解更多 -</span>
                <div class="links-wrapper">
                    <router-link class="link" :to="{name: 'idols'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/大神云集@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'workLib'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/海量作品@2x.png`"></router-link>
                    <router-link class="link" :to="{name: 'classic'}"><img :src="`${GET_STATIC_IMG_HOST}popularize/others/经典汇聚@2x.png`"></router-link>
                </div>
            </div>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-bottom">立即加入</router-link>
            <router-link :to="{name: 'anchorIndex'}" class="btn-join-fixed">立即加入</router-link>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    methods: {
      setXMLog () {
        xmLog('pv.create', {
          item: "有声化平台首页"
        }),
          xmLog("pv.send", "event", {
            serviceId: "aBookView",
            item: "有声化推广页_福利体系"
          })
      }
    },
    computed: {
      GET_STATIC_IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }
    },
    mounted () {

      // 埋点
      this.setXMLog ();
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/icons.scss";
    @import "../../sass/popularize/popularize-first.scss";
</style>



// WEBPACK FOOTER //
// Benefits.vue?6d0091fd